<template>
    <v-container fluid>
        <ReadHeader :current="current" />
        <!-- <h1>{{ entityData.name }}</h1> -->
        <v-row>
            <v-col>
                <KeyValue :title="`Title`" :value="entityData.title"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`Email`" :value="entityData.email"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="4">
                <KeyValue :title="`Phone`" :value="entityData.phone"></KeyValue>
            </v-col>
            <v-col cols="2">
                <KeyValue :title="`Extension`" :value="entityData.phone_extension"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`Mobile`" :value="entityData.mobile"></KeyValue>
            </v-col>
        </v-row>

        <!-- <UserManagement/> -->

    </v-container>
</template>
<script setup>
/* eslint-disable */
import ReadHeader from "@/components/interface/ReadHeader.vue";
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import KeyValue from "@/components/interface/Key-Value.vue";
const route = useRoute();
const store = useStore();
const entityData = ref({});
console.log('route.params.entity_id', route.params.entity_id)
onMounted(async () => {
    console.log('mounted')
    const ownerContact = await store.dispatch("getOwnerContact", route.params.entity_id);
    console.log('ownerContact2', ownerContact);
    entityData.value = ownerContact.data;
    store.dispatch("setBreadcrumbsV2", {
        fullPath: route.fullPath,
        array: ownerContact.meta.ancestors
    });
})
const current = {
    type: "owner_contact",
    id: route.params.entity_id,
};
</script>